import { FC } from "react";

import Box from "@mui/material/Box";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

interface CreateYourOwnPageProps {
  href: string;
}

export const CreateYourOwnPage: FC<CreateYourOwnPageProps> = ({ href }) => {
  const { t } = useTranslate();

  return (
    <FormTypography
      variant="body1"
      vibe="quiet"
      component="p"
      sx={{ textAlign: "center", paddingInline: 2 }}
      data-test="org-page-create-your-own-page"
    >
      {`${t("organization", "createYourOwnPage.question")} `}
      <Box
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "inherit", textDecoration: "underline" }}
      >
        {t("organization", "createYourOwnPage.link")}
      </Box>
    </FormTypography>
  );
};
